/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './pages/__root'
import { Route as IndexRouteImport } from './pages/_index'
import { Route as StudentRouteImport } from './pages/student'
import { Route as AuthenticatedRouteImport } from './pages/_authenticated'
import { Route as StudentIndexRouteImport } from './pages/student/index'
import { Route as IndexIndexRouteImport } from './pages/_index/index'
import { Route as StudentProfileRouteImport } from './pages/student/profile'
import { Route as StudentCoursesRouteImport } from './pages/student/courses'
import { Route as AuthenticatedHomeRouteImport } from './pages/_authenticated/home'
import { Route as AuthenticatedBuildingRouteImport } from './pages/_authenticated/building'
import { Route as IndexCertificadosIndexRouteImport } from './pages/_index/certificados/index'
import { Route as AuthenticatedTreinamentosIndexRouteImport } from './pages/_authenticated/treinamentos/index'
import { Route as AuthenticatedInventariosIndexRouteImport } from './pages/_authenticated/inventarios/index'
import { Route as AuthenticatedIntegracoesIndexRouteImport } from './pages/_authenticated/integracoes/index'
import { Route as AuthenticatedEmpresaIndexRouteImport } from './pages/_authenticated/empresa/index'
import { Route as AuthenticatedClientesIndexRouteImport } from './pages/_authenticated/clientes/index'
import { Route as AuthenticatedBlogIndexRouteImport } from './pages/_authenticated/blog/index'
import { Route as StudentLessonLessonIdRouteImport } from './pages/student/lesson/$lessonId'
import { Route as IndexProvaClassIdRouteImport } from './pages/_index/prova.$classId'
import { Route as IndexCertificadosIdRouteImport } from './pages/_index/certificados/$id'
import { Route as AuthenticatedInventariosDashboardRouteImport } from './pages/_authenticated/inventarios/dashboard'
import { Route as AuthenticatedInventariosAutorizadosRouteImport } from './pages/_authenticated/inventarios/autorizados'
import { Route as AuthenticatedInventariosAccessControlRouteImport } from './pages/_authenticated/inventarios/access-control'
import { Route as StudentCourseCourseIdIndexRouteImport } from './pages/student/course/$courseId.index'
import { Route as AuthenticatedUsuariosUsuariosIndexRouteImport } from './pages/_authenticated/usuarios/_usuarios/index'
import { Route as AuthenticatedTreinamentosAulasOnlineIndexRouteImport } from './pages/_authenticated/treinamentos/aulas-online/index'
import { Route as AuthenticatedInventariosAreasIndexRouteImport } from './pages/_authenticated/inventarios/areas/index'
import { Route as StudentCourseCourseIdLessonsRouteImport } from './pages/student/course/$courseId.lessons'
import { Route as IndexCertificadosNomeIdRouteImport } from './pages/_index/certificados/$nome.$id'
import { Route as IndexAuthStudentLoginRouteImport } from './pages/_index/auth/student/login'
import { Route as AuthenticatedUsuariosPerfisPerfisRouteImport } from './pages/_authenticated/usuarios/_perfis/perfis'
import { Route as AuthenticatedTreinamentosAulasOnlineIdRouteImport } from './pages/_authenticated/treinamentos/aulas-online/$id'
import { Route as AuthenticatedTreinamentosTurmasTurmasRouteImport } from './pages/_authenticated/treinamentos/_turmas/turmas'
import { Route as AuthenticatedTreinamentosInstrutoresInstrutoresRouteImport } from './pages/_authenticated/treinamentos/_instrutores/instrutores'
import { Route as AuthenticatedTreinamentosInscricoesInscricoesRouteImport } from './pages/_authenticated/treinamentos/_inscricoes/inscricoes'
import { Route as AuthenticatedTreinamentosCursosCursosRouteImport } from './pages/_authenticated/treinamentos/_cursos/cursos'
import { Route as AuthenticatedTreinamentosCursosOnlineCursosOnlineRouteImport } from './pages/_authenticated/treinamentos/_cursos-online/cursos-online'
import { Route as AuthenticatedTreinamentosCertificadosCertificadosRouteImport } from './pages/_authenticated/treinamentos/_certificados/certificados'
import { Route as AuthenticatedTreinamentosCertificadosModelosCertificadosModelosRouteImport } from './pages/_authenticated/treinamentos/_certificados-modelos/certificados-modelos'
import { Route as AuthenticatedTreinamentosAlunosAlunosRouteImport } from './pages/_authenticated/treinamentos/_alunos/alunos'
import { Route as AuthenticatedSiteServicosServicosRouteImport } from './pages/_authenticated/site/_servicos/servicos'
import { Route as AuthenticatedSiteProdutosProdutosRouteImport } from './pages/_authenticated/site/_produtos/produtos'
import { Route as AuthenticatedInventariosAreasAreaIdRouteImport } from './pages/_authenticated/inventarios/areas/$areaId'
import { Route as AuthenticatedFinanceiroReceberReceberRouteImport } from './pages/_authenticated/financeiro/_receber/receber'
import { Route as AuthenticatedComercialVendedoresVendedoresRouteImport } from './pages/_authenticated/comercial/_vendedores/vendedores'
import { Route as AuthenticatedComercialCuponsCuponsRouteImport } from './pages/_authenticated/comercial/_cupons/cupons'
import { Route as AuthenticatedBlogVisitantesVisitantesRouteImport } from './pages/_authenticated/blog/_visitantes/visitantes'
import { Route as AuthenticatedBlogTagsTagsRouteImport } from './pages/_authenticated/blog/_tags/tags'
import { Route as AuthenticatedBlogPostsPostsRouteImport } from './pages/_authenticated/blog/_posts/posts'
import { Route as AuthenticatedBlogComentariosComentariosRouteImport } from './pages/_authenticated/blog/_comentarios/comentarios'
import { Route as AuthenticatedBlogCategoriasCategoriasRouteImport } from './pages/_authenticated/blog/_categorias/categorias'

const IndexRoute = IndexRouteImport.update({
  id: '/_index',
  getParentRoute: () => rootRouteImport,
} as any)
const StudentRoute = StudentRouteImport.update({
  id: '/student',
  path: '/student',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const StudentIndexRoute = StudentIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => StudentRoute,
} as any)
const IndexIndexRoute = IndexIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => IndexRoute,
} as any)
const StudentProfileRoute = StudentProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => StudentRoute,
} as any)
const StudentCoursesRoute = StudentCoursesRouteImport.update({
  id: '/courses',
  path: '/courses',
  getParentRoute: () => StudentRoute,
} as any)
const AuthenticatedHomeRoute = AuthenticatedHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedBuildingRoute = AuthenticatedBuildingRouteImport.update({
  id: '/building',
  path: '/building',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const IndexCertificadosIndexRoute = IndexCertificadosIndexRouteImport.update({
  id: '/certificados/',
  path: '/certificados/',
  getParentRoute: () => IndexRoute,
} as any)
const AuthenticatedTreinamentosIndexRoute =
  AuthenticatedTreinamentosIndexRouteImport.update({
    id: '/treinamentos/',
    path: '/treinamentos/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInventariosIndexRoute =
  AuthenticatedInventariosIndexRouteImport.update({
    id: '/inventarios/',
    path: '/inventarios/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIntegracoesIndexRoute =
  AuthenticatedIntegracoesIndexRouteImport.update({
    id: '/integracoes/',
    path: '/integracoes/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedEmpresaIndexRoute =
  AuthenticatedEmpresaIndexRouteImport.update({
    id: '/empresa/',
    path: '/empresa/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedClientesIndexRoute =
  AuthenticatedClientesIndexRouteImport.update({
    id: '/clientes/',
    path: '/clientes/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBlogIndexRoute = AuthenticatedBlogIndexRouteImport.update({
  id: '/blog/',
  path: '/blog/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const StudentLessonLessonIdRoute = StudentLessonLessonIdRouteImport.update({
  id: '/lesson/$lessonId',
  path: '/lesson/$lessonId',
  getParentRoute: () => StudentRoute,
} as any)
const IndexProvaClassIdRoute = IndexProvaClassIdRouteImport.update({
  id: '/prova/$classId',
  path: '/prova/$classId',
  getParentRoute: () => IndexRoute,
} as any)
const IndexCertificadosIdRoute = IndexCertificadosIdRouteImport.update({
  id: '/certificados/$id',
  path: '/certificados/$id',
  getParentRoute: () => IndexRoute,
} as any)
const AuthenticatedInventariosDashboardRoute =
  AuthenticatedInventariosDashboardRouteImport.update({
    id: '/inventarios/dashboard',
    path: '/inventarios/dashboard',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInventariosAutorizadosRoute =
  AuthenticatedInventariosAutorizadosRouteImport.update({
    id: '/inventarios/autorizados',
    path: '/inventarios/autorizados',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInventariosAccessControlRoute =
  AuthenticatedInventariosAccessControlRouteImport.update({
    id: '/inventarios/access-control',
    path: '/inventarios/access-control',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const StudentCourseCourseIdIndexRoute =
  StudentCourseCourseIdIndexRouteImport.update({
    id: '/course/$courseId/',
    path: '/course/$courseId/',
    getParentRoute: () => StudentRoute,
  } as any)
const AuthenticatedUsuariosUsuariosIndexRoute =
  AuthenticatedUsuariosUsuariosIndexRouteImport.update({
    id: '/usuarios/_usuarios/',
    path: '/usuarios/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTreinamentosAulasOnlineIndexRoute =
  AuthenticatedTreinamentosAulasOnlineIndexRouteImport.update({
    id: '/treinamentos/aulas-online/',
    path: '/treinamentos/aulas-online/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInventariosAreasIndexRoute =
  AuthenticatedInventariosAreasIndexRouteImport.update({
    id: '/inventarios/areas/',
    path: '/inventarios/areas/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const StudentCourseCourseIdLessonsRoute =
  StudentCourseCourseIdLessonsRouteImport.update({
    id: '/course/$courseId/lessons',
    path: '/course/$courseId/lessons',
    getParentRoute: () => StudentRoute,
  } as any)
const IndexCertificadosNomeIdRoute = IndexCertificadosNomeIdRouteImport.update({
  id: '/certificados/$nome/$id',
  path: '/certificados/$nome/$id',
  getParentRoute: () => IndexRoute,
} as any)
const IndexAuthStudentLoginRoute = IndexAuthStudentLoginRouteImport.update({
  id: '/auth/student/login',
  path: '/auth/student/login',
  getParentRoute: () => IndexRoute,
} as any)
const AuthenticatedUsuariosPerfisPerfisRoute =
  AuthenticatedUsuariosPerfisPerfisRouteImport.update({
    id: '/usuarios/_perfis/perfis',
    path: '/usuarios/perfis',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTreinamentosAulasOnlineIdRoute =
  AuthenticatedTreinamentosAulasOnlineIdRouteImport.update({
    id: '/treinamentos/aulas-online/$id',
    path: '/treinamentos/aulas-online/$id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTreinamentosTurmasTurmasRoute =
  AuthenticatedTreinamentosTurmasTurmasRouteImport.update({
    id: '/treinamentos/_turmas/turmas',
    path: '/treinamentos/turmas',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTreinamentosInstrutoresInstrutoresRoute =
  AuthenticatedTreinamentosInstrutoresInstrutoresRouteImport.update({
    id: '/treinamentos/_instrutores/instrutores',
    path: '/treinamentos/instrutores',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTreinamentosInscricoesInscricoesRoute =
  AuthenticatedTreinamentosInscricoesInscricoesRouteImport.update({
    id: '/treinamentos/_inscricoes/inscricoes',
    path: '/treinamentos/inscricoes',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTreinamentosCursosCursosRoute =
  AuthenticatedTreinamentosCursosCursosRouteImport.update({
    id: '/treinamentos/_cursos/cursos',
    path: '/treinamentos/cursos',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTreinamentosCursosOnlineCursosOnlineRoute =
  AuthenticatedTreinamentosCursosOnlineCursosOnlineRouteImport.update({
    id: '/treinamentos/_cursos-online/cursos-online',
    path: '/treinamentos/cursos-online',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTreinamentosCertificadosCertificadosRoute =
  AuthenticatedTreinamentosCertificadosCertificadosRouteImport.update({
    id: '/treinamentos/_certificados/certificados',
    path: '/treinamentos/certificados',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTreinamentosCertificadosModelosCertificadosModelosRoute =
  AuthenticatedTreinamentosCertificadosModelosCertificadosModelosRouteImport.update(
    {
      id: '/treinamentos/_certificados-modelos/certificados-modelos',
      path: '/treinamentos/certificados-modelos',
      getParentRoute: () => AuthenticatedRoute,
    } as any,
  )
const AuthenticatedTreinamentosAlunosAlunosRoute =
  AuthenticatedTreinamentosAlunosAlunosRouteImport.update({
    id: '/treinamentos/_alunos/alunos',
    path: '/treinamentos/alunos',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSiteServicosServicosRoute =
  AuthenticatedSiteServicosServicosRouteImport.update({
    id: '/site/_servicos/servicos',
    path: '/site/servicos',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSiteProdutosProdutosRoute =
  AuthenticatedSiteProdutosProdutosRouteImport.update({
    id: '/site/_produtos/produtos',
    path: '/site/produtos',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInventariosAreasAreaIdRoute =
  AuthenticatedInventariosAreasAreaIdRouteImport.update({
    id: '/inventarios/areas/$areaId',
    path: '/inventarios/areas/$areaId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFinanceiroReceberReceberRoute =
  AuthenticatedFinanceiroReceberReceberRouteImport.update({
    id: '/financeiro/_receber/receber',
    path: '/financeiro/receber',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedComercialVendedoresVendedoresRoute =
  AuthenticatedComercialVendedoresVendedoresRouteImport.update({
    id: '/comercial/_vendedores/vendedores',
    path: '/comercial/vendedores',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedComercialCuponsCuponsRoute =
  AuthenticatedComercialCuponsCuponsRouteImport.update({
    id: '/comercial/_cupons/cupons',
    path: '/comercial/cupons',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBlogVisitantesVisitantesRoute =
  AuthenticatedBlogVisitantesVisitantesRouteImport.update({
    id: '/blog/_visitantes/visitantes',
    path: '/blog/visitantes',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBlogTagsTagsRoute =
  AuthenticatedBlogTagsTagsRouteImport.update({
    id: '/blog/_tags/tags',
    path: '/blog/tags',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBlogPostsPostsRoute =
  AuthenticatedBlogPostsPostsRouteImport.update({
    id: '/blog/_posts/posts',
    path: '/blog/posts',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBlogComentariosComentariosRoute =
  AuthenticatedBlogComentariosComentariosRouteImport.update({
    id: '/blog/_comentarios/comentarios',
    path: '/blog/comentarios',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedBlogCategoriasCategoriasRoute =
  AuthenticatedBlogCategoriasCategoriasRouteImport.update({
    id: '/blog/_categorias/categorias',
    path: '/blog/categorias',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/student': typeof StudentRouteWithChildren
  '/building': typeof AuthenticatedBuildingRoute
  '/home': typeof AuthenticatedHomeRoute
  '/student/courses': typeof StudentCoursesRoute
  '/student/profile': typeof StudentProfileRoute
  '/': typeof IndexIndexRoute
  '/student/': typeof StudentIndexRoute
  '/inventarios/access-control': typeof AuthenticatedInventariosAccessControlRoute
  '/inventarios/autorizados': typeof AuthenticatedInventariosAutorizadosRoute
  '/inventarios/dashboard': typeof AuthenticatedInventariosDashboardRoute
  '/certificados/$id': typeof IndexCertificadosIdRoute
  '/prova/$classId': typeof IndexProvaClassIdRoute
  '/student/lesson/$lessonId': typeof StudentLessonLessonIdRoute
  '/blog': typeof AuthenticatedBlogIndexRoute
  '/clientes': typeof AuthenticatedClientesIndexRoute
  '/empresa': typeof AuthenticatedEmpresaIndexRoute
  '/integracoes': typeof AuthenticatedIntegracoesIndexRoute
  '/inventarios': typeof AuthenticatedInventariosIndexRoute
  '/treinamentos': typeof AuthenticatedTreinamentosIndexRoute
  '/certificados': typeof IndexCertificadosIndexRoute
  '/blog/categorias': typeof AuthenticatedBlogCategoriasCategoriasRoute
  '/blog/comentarios': typeof AuthenticatedBlogComentariosComentariosRoute
  '/blog/posts': typeof AuthenticatedBlogPostsPostsRoute
  '/blog/tags': typeof AuthenticatedBlogTagsTagsRoute
  '/blog/visitantes': typeof AuthenticatedBlogVisitantesVisitantesRoute
  '/comercial/cupons': typeof AuthenticatedComercialCuponsCuponsRoute
  '/comercial/vendedores': typeof AuthenticatedComercialVendedoresVendedoresRoute
  '/financeiro/receber': typeof AuthenticatedFinanceiroReceberReceberRoute
  '/inventarios/areas/$areaId': typeof AuthenticatedInventariosAreasAreaIdRoute
  '/site/produtos': typeof AuthenticatedSiteProdutosProdutosRoute
  '/site/servicos': typeof AuthenticatedSiteServicosServicosRoute
  '/treinamentos/alunos': typeof AuthenticatedTreinamentosAlunosAlunosRoute
  '/treinamentos/certificados-modelos': typeof AuthenticatedTreinamentosCertificadosModelosCertificadosModelosRoute
  '/treinamentos/certificados': typeof AuthenticatedTreinamentosCertificadosCertificadosRoute
  '/treinamentos/cursos-online': typeof AuthenticatedTreinamentosCursosOnlineCursosOnlineRoute
  '/treinamentos/cursos': typeof AuthenticatedTreinamentosCursosCursosRoute
  '/treinamentos/inscricoes': typeof AuthenticatedTreinamentosInscricoesInscricoesRoute
  '/treinamentos/instrutores': typeof AuthenticatedTreinamentosInstrutoresInstrutoresRoute
  '/treinamentos/turmas': typeof AuthenticatedTreinamentosTurmasTurmasRoute
  '/treinamentos/aulas-online/$id': typeof AuthenticatedTreinamentosAulasOnlineIdRoute
  '/usuarios/perfis': typeof AuthenticatedUsuariosPerfisPerfisRoute
  '/auth/student/login': typeof IndexAuthStudentLoginRoute
  '/certificados/$nome/$id': typeof IndexCertificadosNomeIdRoute
  '/student/course/$courseId/lessons': typeof StudentCourseCourseIdLessonsRoute
  '/inventarios/areas': typeof AuthenticatedInventariosAreasIndexRoute
  '/treinamentos/aulas-online': typeof AuthenticatedTreinamentosAulasOnlineIndexRoute
  '/usuarios': typeof AuthenticatedUsuariosUsuariosIndexRoute
  '/student/course/$courseId': typeof StudentCourseCourseIdIndexRoute
}
export interface FileRoutesByTo {
  '/building': typeof AuthenticatedBuildingRoute
  '/home': typeof AuthenticatedHomeRoute
  '/student/courses': typeof StudentCoursesRoute
  '/student/profile': typeof StudentProfileRoute
  '/': typeof IndexIndexRoute
  '/student': typeof StudentIndexRoute
  '/inventarios/access-control': typeof AuthenticatedInventariosAccessControlRoute
  '/inventarios/autorizados': typeof AuthenticatedInventariosAutorizadosRoute
  '/inventarios/dashboard': typeof AuthenticatedInventariosDashboardRoute
  '/certificados/$id': typeof IndexCertificadosIdRoute
  '/prova/$classId': typeof IndexProvaClassIdRoute
  '/student/lesson/$lessonId': typeof StudentLessonLessonIdRoute
  '/blog': typeof AuthenticatedBlogIndexRoute
  '/clientes': typeof AuthenticatedClientesIndexRoute
  '/empresa': typeof AuthenticatedEmpresaIndexRoute
  '/integracoes': typeof AuthenticatedIntegracoesIndexRoute
  '/inventarios': typeof AuthenticatedInventariosIndexRoute
  '/treinamentos': typeof AuthenticatedTreinamentosIndexRoute
  '/certificados': typeof IndexCertificadosIndexRoute
  '/blog/categorias': typeof AuthenticatedBlogCategoriasCategoriasRoute
  '/blog/comentarios': typeof AuthenticatedBlogComentariosComentariosRoute
  '/blog/posts': typeof AuthenticatedBlogPostsPostsRoute
  '/blog/tags': typeof AuthenticatedBlogTagsTagsRoute
  '/blog/visitantes': typeof AuthenticatedBlogVisitantesVisitantesRoute
  '/comercial/cupons': typeof AuthenticatedComercialCuponsCuponsRoute
  '/comercial/vendedores': typeof AuthenticatedComercialVendedoresVendedoresRoute
  '/financeiro/receber': typeof AuthenticatedFinanceiroReceberReceberRoute
  '/inventarios/areas/$areaId': typeof AuthenticatedInventariosAreasAreaIdRoute
  '/site/produtos': typeof AuthenticatedSiteProdutosProdutosRoute
  '/site/servicos': typeof AuthenticatedSiteServicosServicosRoute
  '/treinamentos/alunos': typeof AuthenticatedTreinamentosAlunosAlunosRoute
  '/treinamentos/certificados-modelos': typeof AuthenticatedTreinamentosCertificadosModelosCertificadosModelosRoute
  '/treinamentos/certificados': typeof AuthenticatedTreinamentosCertificadosCertificadosRoute
  '/treinamentos/cursos-online': typeof AuthenticatedTreinamentosCursosOnlineCursosOnlineRoute
  '/treinamentos/cursos': typeof AuthenticatedTreinamentosCursosCursosRoute
  '/treinamentos/inscricoes': typeof AuthenticatedTreinamentosInscricoesInscricoesRoute
  '/treinamentos/instrutores': typeof AuthenticatedTreinamentosInstrutoresInstrutoresRoute
  '/treinamentos/turmas': typeof AuthenticatedTreinamentosTurmasTurmasRoute
  '/treinamentos/aulas-online/$id': typeof AuthenticatedTreinamentosAulasOnlineIdRoute
  '/usuarios/perfis': typeof AuthenticatedUsuariosPerfisPerfisRoute
  '/auth/student/login': typeof IndexAuthStudentLoginRoute
  '/certificados/$nome/$id': typeof IndexCertificadosNomeIdRoute
  '/student/course/$courseId/lessons': typeof StudentCourseCourseIdLessonsRoute
  '/inventarios/areas': typeof AuthenticatedInventariosAreasIndexRoute
  '/treinamentos/aulas-online': typeof AuthenticatedTreinamentosAulasOnlineIndexRoute
  '/usuarios': typeof AuthenticatedUsuariosUsuariosIndexRoute
  '/student/course/$courseId': typeof StudentCourseCourseIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/_index': typeof IndexRouteWithChildren
  '/student': typeof StudentRouteWithChildren
  '/_authenticated/building': typeof AuthenticatedBuildingRoute
  '/_authenticated/home': typeof AuthenticatedHomeRoute
  '/student/courses': typeof StudentCoursesRoute
  '/student/profile': typeof StudentProfileRoute
  '/_index/': typeof IndexIndexRoute
  '/student/': typeof StudentIndexRoute
  '/_authenticated/inventarios/access-control': typeof AuthenticatedInventariosAccessControlRoute
  '/_authenticated/inventarios/autorizados': typeof AuthenticatedInventariosAutorizadosRoute
  '/_authenticated/inventarios/dashboard': typeof AuthenticatedInventariosDashboardRoute
  '/_index/certificados/$id': typeof IndexCertificadosIdRoute
  '/_index/prova/$classId': typeof IndexProvaClassIdRoute
  '/student/lesson/$lessonId': typeof StudentLessonLessonIdRoute
  '/_authenticated/blog/': typeof AuthenticatedBlogIndexRoute
  '/_authenticated/clientes/': typeof AuthenticatedClientesIndexRoute
  '/_authenticated/empresa/': typeof AuthenticatedEmpresaIndexRoute
  '/_authenticated/integracoes/': typeof AuthenticatedIntegracoesIndexRoute
  '/_authenticated/inventarios/': typeof AuthenticatedInventariosIndexRoute
  '/_authenticated/treinamentos/': typeof AuthenticatedTreinamentosIndexRoute
  '/_index/certificados/': typeof IndexCertificadosIndexRoute
  '/_authenticated/blog/_categorias/categorias': typeof AuthenticatedBlogCategoriasCategoriasRoute
  '/_authenticated/blog/_comentarios/comentarios': typeof AuthenticatedBlogComentariosComentariosRoute
  '/_authenticated/blog/_posts/posts': typeof AuthenticatedBlogPostsPostsRoute
  '/_authenticated/blog/_tags/tags': typeof AuthenticatedBlogTagsTagsRoute
  '/_authenticated/blog/_visitantes/visitantes': typeof AuthenticatedBlogVisitantesVisitantesRoute
  '/_authenticated/comercial/_cupons/cupons': typeof AuthenticatedComercialCuponsCuponsRoute
  '/_authenticated/comercial/_vendedores/vendedores': typeof AuthenticatedComercialVendedoresVendedoresRoute
  '/_authenticated/financeiro/_receber/receber': typeof AuthenticatedFinanceiroReceberReceberRoute
  '/_authenticated/inventarios/areas/$areaId': typeof AuthenticatedInventariosAreasAreaIdRoute
  '/_authenticated/site/_produtos/produtos': typeof AuthenticatedSiteProdutosProdutosRoute
  '/_authenticated/site/_servicos/servicos': typeof AuthenticatedSiteServicosServicosRoute
  '/_authenticated/treinamentos/_alunos/alunos': typeof AuthenticatedTreinamentosAlunosAlunosRoute
  '/_authenticated/treinamentos/_certificados-modelos/certificados-modelos': typeof AuthenticatedTreinamentosCertificadosModelosCertificadosModelosRoute
  '/_authenticated/treinamentos/_certificados/certificados': typeof AuthenticatedTreinamentosCertificadosCertificadosRoute
  '/_authenticated/treinamentos/_cursos-online/cursos-online': typeof AuthenticatedTreinamentosCursosOnlineCursosOnlineRoute
  '/_authenticated/treinamentos/_cursos/cursos': typeof AuthenticatedTreinamentosCursosCursosRoute
  '/_authenticated/treinamentos/_inscricoes/inscricoes': typeof AuthenticatedTreinamentosInscricoesInscricoesRoute
  '/_authenticated/treinamentos/_instrutores/instrutores': typeof AuthenticatedTreinamentosInstrutoresInstrutoresRoute
  '/_authenticated/treinamentos/_turmas/turmas': typeof AuthenticatedTreinamentosTurmasTurmasRoute
  '/_authenticated/treinamentos/aulas-online/$id': typeof AuthenticatedTreinamentosAulasOnlineIdRoute
  '/_authenticated/usuarios/_perfis/perfis': typeof AuthenticatedUsuariosPerfisPerfisRoute
  '/_index/auth/student/login': typeof IndexAuthStudentLoginRoute
  '/_index/certificados/$nome/$id': typeof IndexCertificadosNomeIdRoute
  '/student/course/$courseId/lessons': typeof StudentCourseCourseIdLessonsRoute
  '/_authenticated/inventarios/areas/': typeof AuthenticatedInventariosAreasIndexRoute
  '/_authenticated/treinamentos/aulas-online/': typeof AuthenticatedTreinamentosAulasOnlineIndexRoute
  '/_authenticated/usuarios/_usuarios/': typeof AuthenticatedUsuariosUsuariosIndexRoute
  '/student/course/$courseId/': typeof StudentCourseCourseIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/student'
    | '/building'
    | '/home'
    | '/student/courses'
    | '/student/profile'
    | '/'
    | '/student/'
    | '/inventarios/access-control'
    | '/inventarios/autorizados'
    | '/inventarios/dashboard'
    | '/certificados/$id'
    | '/prova/$classId'
    | '/student/lesson/$lessonId'
    | '/blog'
    | '/clientes'
    | '/empresa'
    | '/integracoes'
    | '/inventarios'
    | '/treinamentos'
    | '/certificados'
    | '/blog/categorias'
    | '/blog/comentarios'
    | '/blog/posts'
    | '/blog/tags'
    | '/blog/visitantes'
    | '/comercial/cupons'
    | '/comercial/vendedores'
    | '/financeiro/receber'
    | '/inventarios/areas/$areaId'
    | '/site/produtos'
    | '/site/servicos'
    | '/treinamentos/alunos'
    | '/treinamentos/certificados-modelos'
    | '/treinamentos/certificados'
    | '/treinamentos/cursos-online'
    | '/treinamentos/cursos'
    | '/treinamentos/inscricoes'
    | '/treinamentos/instrutores'
    | '/treinamentos/turmas'
    | '/treinamentos/aulas-online/$id'
    | '/usuarios/perfis'
    | '/auth/student/login'
    | '/certificados/$nome/$id'
    | '/student/course/$courseId/lessons'
    | '/inventarios/areas'
    | '/treinamentos/aulas-online'
    | '/usuarios'
    | '/student/course/$courseId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/building'
    | '/home'
    | '/student/courses'
    | '/student/profile'
    | '/'
    | '/student'
    | '/inventarios/access-control'
    | '/inventarios/autorizados'
    | '/inventarios/dashboard'
    | '/certificados/$id'
    | '/prova/$classId'
    | '/student/lesson/$lessonId'
    | '/blog'
    | '/clientes'
    | '/empresa'
    | '/integracoes'
    | '/inventarios'
    | '/treinamentos'
    | '/certificados'
    | '/blog/categorias'
    | '/blog/comentarios'
    | '/blog/posts'
    | '/blog/tags'
    | '/blog/visitantes'
    | '/comercial/cupons'
    | '/comercial/vendedores'
    | '/financeiro/receber'
    | '/inventarios/areas/$areaId'
    | '/site/produtos'
    | '/site/servicos'
    | '/treinamentos/alunos'
    | '/treinamentos/certificados-modelos'
    | '/treinamentos/certificados'
    | '/treinamentos/cursos-online'
    | '/treinamentos/cursos'
    | '/treinamentos/inscricoes'
    | '/treinamentos/instrutores'
    | '/treinamentos/turmas'
    | '/treinamentos/aulas-online/$id'
    | '/usuarios/perfis'
    | '/auth/student/login'
    | '/certificados/$nome/$id'
    | '/student/course/$courseId/lessons'
    | '/inventarios/areas'
    | '/treinamentos/aulas-online'
    | '/usuarios'
    | '/student/course/$courseId'
  id:
    | '__root__'
    | '/_authenticated'
    | '/_index'
    | '/student'
    | '/_authenticated/building'
    | '/_authenticated/home'
    | '/student/courses'
    | '/student/profile'
    | '/_index/'
    | '/student/'
    | '/_authenticated/inventarios/access-control'
    | '/_authenticated/inventarios/autorizados'
    | '/_authenticated/inventarios/dashboard'
    | '/_index/certificados/$id'
    | '/_index/prova/$classId'
    | '/student/lesson/$lessonId'
    | '/_authenticated/blog/'
    | '/_authenticated/clientes/'
    | '/_authenticated/empresa/'
    | '/_authenticated/integracoes/'
    | '/_authenticated/inventarios/'
    | '/_authenticated/treinamentos/'
    | '/_index/certificados/'
    | '/_authenticated/blog/_categorias/categorias'
    | '/_authenticated/blog/_comentarios/comentarios'
    | '/_authenticated/blog/_posts/posts'
    | '/_authenticated/blog/_tags/tags'
    | '/_authenticated/blog/_visitantes/visitantes'
    | '/_authenticated/comercial/_cupons/cupons'
    | '/_authenticated/comercial/_vendedores/vendedores'
    | '/_authenticated/financeiro/_receber/receber'
    | '/_authenticated/inventarios/areas/$areaId'
    | '/_authenticated/site/_produtos/produtos'
    | '/_authenticated/site/_servicos/servicos'
    | '/_authenticated/treinamentos/_alunos/alunos'
    | '/_authenticated/treinamentos/_certificados-modelos/certificados-modelos'
    | '/_authenticated/treinamentos/_certificados/certificados'
    | '/_authenticated/treinamentos/_cursos-online/cursos-online'
    | '/_authenticated/treinamentos/_cursos/cursos'
    | '/_authenticated/treinamentos/_inscricoes/inscricoes'
    | '/_authenticated/treinamentos/_instrutores/instrutores'
    | '/_authenticated/treinamentos/_turmas/turmas'
    | '/_authenticated/treinamentos/aulas-online/$id'
    | '/_authenticated/usuarios/_perfis/perfis'
    | '/_index/auth/student/login'
    | '/_index/certificados/$nome/$id'
    | '/student/course/$courseId/lessons'
    | '/_authenticated/inventarios/areas/'
    | '/_authenticated/treinamentos/aulas-online/'
    | '/_authenticated/usuarios/_usuarios/'
    | '/student/course/$courseId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  IndexRoute: typeof IndexRouteWithChildren
  StudentRoute: typeof StudentRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_index': {
      id: '/_index'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/student': {
      id: '/student'
      path: '/student'
      fullPath: '/student'
      preLoaderRoute: typeof StudentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/student/': {
      id: '/student/'
      path: '/'
      fullPath: '/student/'
      preLoaderRoute: typeof StudentIndexRouteImport
      parentRoute: typeof StudentRoute
    }
    '/_index/': {
      id: '/_index/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexIndexRouteImport
      parentRoute: typeof IndexRoute
    }
    '/student/profile': {
      id: '/student/profile'
      path: '/profile'
      fullPath: '/student/profile'
      preLoaderRoute: typeof StudentProfileRouteImport
      parentRoute: typeof StudentRoute
    }
    '/student/courses': {
      id: '/student/courses'
      path: '/courses'
      fullPath: '/student/courses'
      preLoaderRoute: typeof StudentCoursesRouteImport
      parentRoute: typeof StudentRoute
    }
    '/_authenticated/home': {
      id: '/_authenticated/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AuthenticatedHomeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/building': {
      id: '/_authenticated/building'
      path: '/building'
      fullPath: '/building'
      preLoaderRoute: typeof AuthenticatedBuildingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_index/certificados/': {
      id: '/_index/certificados/'
      path: '/certificados'
      fullPath: '/certificados'
      preLoaderRoute: typeof IndexCertificadosIndexRouteImport
      parentRoute: typeof IndexRoute
    }
    '/_authenticated/treinamentos/': {
      id: '/_authenticated/treinamentos/'
      path: '/treinamentos'
      fullPath: '/treinamentos'
      preLoaderRoute: typeof AuthenticatedTreinamentosIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inventarios/': {
      id: '/_authenticated/inventarios/'
      path: '/inventarios'
      fullPath: '/inventarios'
      preLoaderRoute: typeof AuthenticatedInventariosIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/integracoes/': {
      id: '/_authenticated/integracoes/'
      path: '/integracoes'
      fullPath: '/integracoes'
      preLoaderRoute: typeof AuthenticatedIntegracoesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/empresa/': {
      id: '/_authenticated/empresa/'
      path: '/empresa'
      fullPath: '/empresa'
      preLoaderRoute: typeof AuthenticatedEmpresaIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/clientes/': {
      id: '/_authenticated/clientes/'
      path: '/clientes'
      fullPath: '/clientes'
      preLoaderRoute: typeof AuthenticatedClientesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/blog/': {
      id: '/_authenticated/blog/'
      path: '/blog'
      fullPath: '/blog'
      preLoaderRoute: typeof AuthenticatedBlogIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/student/lesson/$lessonId': {
      id: '/student/lesson/$lessonId'
      path: '/lesson/$lessonId'
      fullPath: '/student/lesson/$lessonId'
      preLoaderRoute: typeof StudentLessonLessonIdRouteImport
      parentRoute: typeof StudentRoute
    }
    '/_index/prova/$classId': {
      id: '/_index/prova/$classId'
      path: '/prova/$classId'
      fullPath: '/prova/$classId'
      preLoaderRoute: typeof IndexProvaClassIdRouteImport
      parentRoute: typeof IndexRoute
    }
    '/_index/certificados/$id': {
      id: '/_index/certificados/$id'
      path: '/certificados/$id'
      fullPath: '/certificados/$id'
      preLoaderRoute: typeof IndexCertificadosIdRouteImport
      parentRoute: typeof IndexRoute
    }
    '/_authenticated/inventarios/dashboard': {
      id: '/_authenticated/inventarios/dashboard'
      path: '/inventarios/dashboard'
      fullPath: '/inventarios/dashboard'
      preLoaderRoute: typeof AuthenticatedInventariosDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inventarios/autorizados': {
      id: '/_authenticated/inventarios/autorizados'
      path: '/inventarios/autorizados'
      fullPath: '/inventarios/autorizados'
      preLoaderRoute: typeof AuthenticatedInventariosAutorizadosRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inventarios/access-control': {
      id: '/_authenticated/inventarios/access-control'
      path: '/inventarios/access-control'
      fullPath: '/inventarios/access-control'
      preLoaderRoute: typeof AuthenticatedInventariosAccessControlRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/student/course/$courseId/': {
      id: '/student/course/$courseId/'
      path: '/course/$courseId'
      fullPath: '/student/course/$courseId'
      preLoaderRoute: typeof StudentCourseCourseIdIndexRouteImport
      parentRoute: typeof StudentRoute
    }
    '/_authenticated/usuarios/_usuarios/': {
      id: '/_authenticated/usuarios/_usuarios/'
      path: '/usuarios'
      fullPath: '/usuarios'
      preLoaderRoute: typeof AuthenticatedUsuariosUsuariosIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/treinamentos/aulas-online/': {
      id: '/_authenticated/treinamentos/aulas-online/'
      path: '/treinamentos/aulas-online'
      fullPath: '/treinamentos/aulas-online'
      preLoaderRoute: typeof AuthenticatedTreinamentosAulasOnlineIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inventarios/areas/': {
      id: '/_authenticated/inventarios/areas/'
      path: '/inventarios/areas'
      fullPath: '/inventarios/areas'
      preLoaderRoute: typeof AuthenticatedInventariosAreasIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/student/course/$courseId/lessons': {
      id: '/student/course/$courseId/lessons'
      path: '/course/$courseId/lessons'
      fullPath: '/student/course/$courseId/lessons'
      preLoaderRoute: typeof StudentCourseCourseIdLessonsRouteImport
      parentRoute: typeof StudentRoute
    }
    '/_index/certificados/$nome/$id': {
      id: '/_index/certificados/$nome/$id'
      path: '/certificados/$nome/$id'
      fullPath: '/certificados/$nome/$id'
      preLoaderRoute: typeof IndexCertificadosNomeIdRouteImport
      parentRoute: typeof IndexRoute
    }
    '/_index/auth/student/login': {
      id: '/_index/auth/student/login'
      path: '/auth/student/login'
      fullPath: '/auth/student/login'
      preLoaderRoute: typeof IndexAuthStudentLoginRouteImport
      parentRoute: typeof IndexRoute
    }
    '/_authenticated/usuarios/_perfis/perfis': {
      id: '/_authenticated/usuarios/_perfis/perfis'
      path: '/usuarios/perfis'
      fullPath: '/usuarios/perfis'
      preLoaderRoute: typeof AuthenticatedUsuariosPerfisPerfisRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/treinamentos/aulas-online/$id': {
      id: '/_authenticated/treinamentos/aulas-online/$id'
      path: '/treinamentos/aulas-online/$id'
      fullPath: '/treinamentos/aulas-online/$id'
      preLoaderRoute: typeof AuthenticatedTreinamentosAulasOnlineIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/treinamentos/_turmas/turmas': {
      id: '/_authenticated/treinamentos/_turmas/turmas'
      path: '/treinamentos/turmas'
      fullPath: '/treinamentos/turmas'
      preLoaderRoute: typeof AuthenticatedTreinamentosTurmasTurmasRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/treinamentos/_instrutores/instrutores': {
      id: '/_authenticated/treinamentos/_instrutores/instrutores'
      path: '/treinamentos/instrutores'
      fullPath: '/treinamentos/instrutores'
      preLoaderRoute: typeof AuthenticatedTreinamentosInstrutoresInstrutoresRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/treinamentos/_inscricoes/inscricoes': {
      id: '/_authenticated/treinamentos/_inscricoes/inscricoes'
      path: '/treinamentos/inscricoes'
      fullPath: '/treinamentos/inscricoes'
      preLoaderRoute: typeof AuthenticatedTreinamentosInscricoesInscricoesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/treinamentos/_cursos/cursos': {
      id: '/_authenticated/treinamentos/_cursos/cursos'
      path: '/treinamentos/cursos'
      fullPath: '/treinamentos/cursos'
      preLoaderRoute: typeof AuthenticatedTreinamentosCursosCursosRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/treinamentos/_cursos-online/cursos-online': {
      id: '/_authenticated/treinamentos/_cursos-online/cursos-online'
      path: '/treinamentos/cursos-online'
      fullPath: '/treinamentos/cursos-online'
      preLoaderRoute: typeof AuthenticatedTreinamentosCursosOnlineCursosOnlineRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/treinamentos/_certificados/certificados': {
      id: '/_authenticated/treinamentos/_certificados/certificados'
      path: '/treinamentos/certificados'
      fullPath: '/treinamentos/certificados'
      preLoaderRoute: typeof AuthenticatedTreinamentosCertificadosCertificadosRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/treinamentos/_certificados-modelos/certificados-modelos': {
      id: '/_authenticated/treinamentos/_certificados-modelos/certificados-modelos'
      path: '/treinamentos/certificados-modelos'
      fullPath: '/treinamentos/certificados-modelos'
      preLoaderRoute: typeof AuthenticatedTreinamentosCertificadosModelosCertificadosModelosRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/treinamentos/_alunos/alunos': {
      id: '/_authenticated/treinamentos/_alunos/alunos'
      path: '/treinamentos/alunos'
      fullPath: '/treinamentos/alunos'
      preLoaderRoute: typeof AuthenticatedTreinamentosAlunosAlunosRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/site/_servicos/servicos': {
      id: '/_authenticated/site/_servicos/servicos'
      path: '/site/servicos'
      fullPath: '/site/servicos'
      preLoaderRoute: typeof AuthenticatedSiteServicosServicosRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/site/_produtos/produtos': {
      id: '/_authenticated/site/_produtos/produtos'
      path: '/site/produtos'
      fullPath: '/site/produtos'
      preLoaderRoute: typeof AuthenticatedSiteProdutosProdutosRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/inventarios/areas/$areaId': {
      id: '/_authenticated/inventarios/areas/$areaId'
      path: '/inventarios/areas/$areaId'
      fullPath: '/inventarios/areas/$areaId'
      preLoaderRoute: typeof AuthenticatedInventariosAreasAreaIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/financeiro/_receber/receber': {
      id: '/_authenticated/financeiro/_receber/receber'
      path: '/financeiro/receber'
      fullPath: '/financeiro/receber'
      preLoaderRoute: typeof AuthenticatedFinanceiroReceberReceberRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/comercial/_vendedores/vendedores': {
      id: '/_authenticated/comercial/_vendedores/vendedores'
      path: '/comercial/vendedores'
      fullPath: '/comercial/vendedores'
      preLoaderRoute: typeof AuthenticatedComercialVendedoresVendedoresRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/comercial/_cupons/cupons': {
      id: '/_authenticated/comercial/_cupons/cupons'
      path: '/comercial/cupons'
      fullPath: '/comercial/cupons'
      preLoaderRoute: typeof AuthenticatedComercialCuponsCuponsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/blog/_visitantes/visitantes': {
      id: '/_authenticated/blog/_visitantes/visitantes'
      path: '/blog/visitantes'
      fullPath: '/blog/visitantes'
      preLoaderRoute: typeof AuthenticatedBlogVisitantesVisitantesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/blog/_tags/tags': {
      id: '/_authenticated/blog/_tags/tags'
      path: '/blog/tags'
      fullPath: '/blog/tags'
      preLoaderRoute: typeof AuthenticatedBlogTagsTagsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/blog/_posts/posts': {
      id: '/_authenticated/blog/_posts/posts'
      path: '/blog/posts'
      fullPath: '/blog/posts'
      preLoaderRoute: typeof AuthenticatedBlogPostsPostsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/blog/_comentarios/comentarios': {
      id: '/_authenticated/blog/_comentarios/comentarios'
      path: '/blog/comentarios'
      fullPath: '/blog/comentarios'
      preLoaderRoute: typeof AuthenticatedBlogComentariosComentariosRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/blog/_categorias/categorias': {
      id: '/_authenticated/blog/_categorias/categorias'
      path: '/blog/categorias'
      fullPath: '/blog/categorias'
      preLoaderRoute: typeof AuthenticatedBlogCategoriasCategoriasRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedBuildingRoute: typeof AuthenticatedBuildingRoute
  AuthenticatedHomeRoute: typeof AuthenticatedHomeRoute
  AuthenticatedInventariosAccessControlRoute: typeof AuthenticatedInventariosAccessControlRoute
  AuthenticatedInventariosAutorizadosRoute: typeof AuthenticatedInventariosAutorizadosRoute
  AuthenticatedInventariosDashboardRoute: typeof AuthenticatedInventariosDashboardRoute
  AuthenticatedBlogIndexRoute: typeof AuthenticatedBlogIndexRoute
  AuthenticatedClientesIndexRoute: typeof AuthenticatedClientesIndexRoute
  AuthenticatedEmpresaIndexRoute: typeof AuthenticatedEmpresaIndexRoute
  AuthenticatedIntegracoesIndexRoute: typeof AuthenticatedIntegracoesIndexRoute
  AuthenticatedInventariosIndexRoute: typeof AuthenticatedInventariosIndexRoute
  AuthenticatedTreinamentosIndexRoute: typeof AuthenticatedTreinamentosIndexRoute
  AuthenticatedBlogCategoriasCategoriasRoute: typeof AuthenticatedBlogCategoriasCategoriasRoute
  AuthenticatedBlogComentariosComentariosRoute: typeof AuthenticatedBlogComentariosComentariosRoute
  AuthenticatedBlogPostsPostsRoute: typeof AuthenticatedBlogPostsPostsRoute
  AuthenticatedBlogTagsTagsRoute: typeof AuthenticatedBlogTagsTagsRoute
  AuthenticatedBlogVisitantesVisitantesRoute: typeof AuthenticatedBlogVisitantesVisitantesRoute
  AuthenticatedComercialCuponsCuponsRoute: typeof AuthenticatedComercialCuponsCuponsRoute
  AuthenticatedComercialVendedoresVendedoresRoute: typeof AuthenticatedComercialVendedoresVendedoresRoute
  AuthenticatedFinanceiroReceberReceberRoute: typeof AuthenticatedFinanceiroReceberReceberRoute
  AuthenticatedInventariosAreasAreaIdRoute: typeof AuthenticatedInventariosAreasAreaIdRoute
  AuthenticatedSiteProdutosProdutosRoute: typeof AuthenticatedSiteProdutosProdutosRoute
  AuthenticatedSiteServicosServicosRoute: typeof AuthenticatedSiteServicosServicosRoute
  AuthenticatedTreinamentosAlunosAlunosRoute: typeof AuthenticatedTreinamentosAlunosAlunosRoute
  AuthenticatedTreinamentosCertificadosModelosCertificadosModelosRoute: typeof AuthenticatedTreinamentosCertificadosModelosCertificadosModelosRoute
  AuthenticatedTreinamentosCertificadosCertificadosRoute: typeof AuthenticatedTreinamentosCertificadosCertificadosRoute
  AuthenticatedTreinamentosCursosOnlineCursosOnlineRoute: typeof AuthenticatedTreinamentosCursosOnlineCursosOnlineRoute
  AuthenticatedTreinamentosCursosCursosRoute: typeof AuthenticatedTreinamentosCursosCursosRoute
  AuthenticatedTreinamentosInscricoesInscricoesRoute: typeof AuthenticatedTreinamentosInscricoesInscricoesRoute
  AuthenticatedTreinamentosInstrutoresInstrutoresRoute: typeof AuthenticatedTreinamentosInstrutoresInstrutoresRoute
  AuthenticatedTreinamentosTurmasTurmasRoute: typeof AuthenticatedTreinamentosTurmasTurmasRoute
  AuthenticatedTreinamentosAulasOnlineIdRoute: typeof AuthenticatedTreinamentosAulasOnlineIdRoute
  AuthenticatedUsuariosPerfisPerfisRoute: typeof AuthenticatedUsuariosPerfisPerfisRoute
  AuthenticatedInventariosAreasIndexRoute: typeof AuthenticatedInventariosAreasIndexRoute
  AuthenticatedTreinamentosAulasOnlineIndexRoute: typeof AuthenticatedTreinamentosAulasOnlineIndexRoute
  AuthenticatedUsuariosUsuariosIndexRoute: typeof AuthenticatedUsuariosUsuariosIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedBuildingRoute: AuthenticatedBuildingRoute,
  AuthenticatedHomeRoute: AuthenticatedHomeRoute,
  AuthenticatedInventariosAccessControlRoute:
    AuthenticatedInventariosAccessControlRoute,
  AuthenticatedInventariosAutorizadosRoute:
    AuthenticatedInventariosAutorizadosRoute,
  AuthenticatedInventariosDashboardRoute:
    AuthenticatedInventariosDashboardRoute,
  AuthenticatedBlogIndexRoute: AuthenticatedBlogIndexRoute,
  AuthenticatedClientesIndexRoute: AuthenticatedClientesIndexRoute,
  AuthenticatedEmpresaIndexRoute: AuthenticatedEmpresaIndexRoute,
  AuthenticatedIntegracoesIndexRoute: AuthenticatedIntegracoesIndexRoute,
  AuthenticatedInventariosIndexRoute: AuthenticatedInventariosIndexRoute,
  AuthenticatedTreinamentosIndexRoute: AuthenticatedTreinamentosIndexRoute,
  AuthenticatedBlogCategoriasCategoriasRoute:
    AuthenticatedBlogCategoriasCategoriasRoute,
  AuthenticatedBlogComentariosComentariosRoute:
    AuthenticatedBlogComentariosComentariosRoute,
  AuthenticatedBlogPostsPostsRoute: AuthenticatedBlogPostsPostsRoute,
  AuthenticatedBlogTagsTagsRoute: AuthenticatedBlogTagsTagsRoute,
  AuthenticatedBlogVisitantesVisitantesRoute:
    AuthenticatedBlogVisitantesVisitantesRoute,
  AuthenticatedComercialCuponsCuponsRoute:
    AuthenticatedComercialCuponsCuponsRoute,
  AuthenticatedComercialVendedoresVendedoresRoute:
    AuthenticatedComercialVendedoresVendedoresRoute,
  AuthenticatedFinanceiroReceberReceberRoute:
    AuthenticatedFinanceiroReceberReceberRoute,
  AuthenticatedInventariosAreasAreaIdRoute:
    AuthenticatedInventariosAreasAreaIdRoute,
  AuthenticatedSiteProdutosProdutosRoute:
    AuthenticatedSiteProdutosProdutosRoute,
  AuthenticatedSiteServicosServicosRoute:
    AuthenticatedSiteServicosServicosRoute,
  AuthenticatedTreinamentosAlunosAlunosRoute:
    AuthenticatedTreinamentosAlunosAlunosRoute,
  AuthenticatedTreinamentosCertificadosModelosCertificadosModelosRoute:
    AuthenticatedTreinamentosCertificadosModelosCertificadosModelosRoute,
  AuthenticatedTreinamentosCertificadosCertificadosRoute:
    AuthenticatedTreinamentosCertificadosCertificadosRoute,
  AuthenticatedTreinamentosCursosOnlineCursosOnlineRoute:
    AuthenticatedTreinamentosCursosOnlineCursosOnlineRoute,
  AuthenticatedTreinamentosCursosCursosRoute:
    AuthenticatedTreinamentosCursosCursosRoute,
  AuthenticatedTreinamentosInscricoesInscricoesRoute:
    AuthenticatedTreinamentosInscricoesInscricoesRoute,
  AuthenticatedTreinamentosInstrutoresInstrutoresRoute:
    AuthenticatedTreinamentosInstrutoresInstrutoresRoute,
  AuthenticatedTreinamentosTurmasTurmasRoute:
    AuthenticatedTreinamentosTurmasTurmasRoute,
  AuthenticatedTreinamentosAulasOnlineIdRoute:
    AuthenticatedTreinamentosAulasOnlineIdRoute,
  AuthenticatedUsuariosPerfisPerfisRoute:
    AuthenticatedUsuariosPerfisPerfisRoute,
  AuthenticatedInventariosAreasIndexRoute:
    AuthenticatedInventariosAreasIndexRoute,
  AuthenticatedTreinamentosAulasOnlineIndexRoute:
    AuthenticatedTreinamentosAulasOnlineIndexRoute,
  AuthenticatedUsuariosUsuariosIndexRoute:
    AuthenticatedUsuariosUsuariosIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

interface IndexRouteChildren {
  IndexIndexRoute: typeof IndexIndexRoute
  IndexCertificadosIdRoute: typeof IndexCertificadosIdRoute
  IndexProvaClassIdRoute: typeof IndexProvaClassIdRoute
  IndexCertificadosIndexRoute: typeof IndexCertificadosIndexRoute
  IndexAuthStudentLoginRoute: typeof IndexAuthStudentLoginRoute
  IndexCertificadosNomeIdRoute: typeof IndexCertificadosNomeIdRoute
}

const IndexRouteChildren: IndexRouteChildren = {
  IndexIndexRoute: IndexIndexRoute,
  IndexCertificadosIdRoute: IndexCertificadosIdRoute,
  IndexProvaClassIdRoute: IndexProvaClassIdRoute,
  IndexCertificadosIndexRoute: IndexCertificadosIndexRoute,
  IndexAuthStudentLoginRoute: IndexAuthStudentLoginRoute,
  IndexCertificadosNomeIdRoute: IndexCertificadosNomeIdRoute,
}

const IndexRouteWithChildren = IndexRoute._addFileChildren(IndexRouteChildren)

interface StudentRouteChildren {
  StudentCoursesRoute: typeof StudentCoursesRoute
  StudentProfileRoute: typeof StudentProfileRoute
  StudentIndexRoute: typeof StudentIndexRoute
  StudentLessonLessonIdRoute: typeof StudentLessonLessonIdRoute
  StudentCourseCourseIdLessonsRoute: typeof StudentCourseCourseIdLessonsRoute
  StudentCourseCourseIdIndexRoute: typeof StudentCourseCourseIdIndexRoute
}

const StudentRouteChildren: StudentRouteChildren = {
  StudentCoursesRoute: StudentCoursesRoute,
  StudentProfileRoute: StudentProfileRoute,
  StudentIndexRoute: StudentIndexRoute,
  StudentLessonLessonIdRoute: StudentLessonLessonIdRoute,
  StudentCourseCourseIdLessonsRoute: StudentCourseCourseIdLessonsRoute,
  StudentCourseCourseIdIndexRoute: StudentCourseCourseIdIndexRoute,
}

const StudentRouteWithChildren =
  StudentRoute._addFileChildren(StudentRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  IndexRoute: IndexRouteWithChildren,
  StudentRoute: StudentRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
